import { useGetPrices } from '../../Calculator/hooks/useGetPrices';
import { TaxCalculator } from './TaxCalculator';
import { TradeCalculator, TradeCalculatorLoading } from './TradeCalculator';

export const CalculatorArea = ({
  includeTaxes,
}: {
  includeTaxes?: boolean;
}) => {
  const { coins, currencies, loading } = useGetPrices();
  if (loading) {
    return <TradeCalculatorLoading />;
  }
  return includeTaxes ? (
    <TaxCalculator coins={coins} currencies={currencies} />
  ) : (
    <TradeCalculator coins={coins} currencies={currencies} />
  );
};
